import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} className="my-auto">
            <h3 className="h3_head">
              Tech Stack Our <span>Mobile Application Development</span> Company
              Leverage
            </h3>
          </Col>
          <Col xs={12} md={5} lg={5} className="my-auto">
            <p>
              Empowering your apps with novel, high-end, and in-demand tech
              stacks for consistent performance and innovation.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Languages">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/javascript.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>JavaScript</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/csharp.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Csharp</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/java.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/vector.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Kotlin</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/python.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Python</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/swift.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Swift</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/apple_objective.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Objective-C</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            {/* <Tab eventKey="4" title="Technologies">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/technology/AiMl.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>AIML</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/technology/beacons.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Beacons</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/technology/block_chain.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Block Chain</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/technology/IoT.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>IOT</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/technology/NFC.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>NFC</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/technology/voice_recognition.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Voice Recognition</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/technology/VR.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>VR</h6>
                  </div>
                </li>
              </ul>
            </Tab> */}
            <Tab eventKey="2" title="Frameworks">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/framwork/cordova.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Cordova</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/framwork/flutter.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Flutter</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/framwork/ionic.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Ionic</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/framwork/native_script.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Native Script</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/framwork/react_native.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>React Native</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/framwork/xamarin.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Xamarin</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Cloud">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/cloud/aws.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/cloud/azure.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/cloud/google_cloud.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/cloud/firebase.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Firebase</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/mobile-app/cloud/ibm.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>IBM</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
